import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-itams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-itams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { ViewApplicationDetailsItamsConstants } from "./view-application-details-itams.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AutoUnsubPortal } from "../../../../shared/decorators/autounsub-portal.decorator";
let ViewApplicationDetailsItamsComponent = class ViewApplicationDetailsItamsComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    changeDetectorRef;
    routerParamsService;
    // Labels
    descriptionLabel = ViewApplicationDetailsItamsConstants.DESCRIPTION_LABEL;
    applicationTypeLabel = ViewApplicationDetailsItamsConstants.APPLICATION_TYPE_LABEL;
    tradingGoodsLabel = ViewApplicationDetailsItamsConstants.TRADING_GOODS_LABEL;
    tradingGoodsDescriptionLabel = ViewApplicationDetailsItamsConstants.TRADING_GOODS_DESCRIPTION_LABEL;
    previousApplicationReferenceNumberLabel = ViewApplicationDetailsItamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_LABEL;
    // Form controls
    tradeGoodsFormArray = ViewApplicationDetailsItamsConstants.TRADING_GOODS_FORM_ARRAY_NAME;
    descriptionFormControlName = ViewApplicationDetailsItamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationDetailsItamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    tradingGoodsDescriptionFormControlName = ViewApplicationDetailsItamsConstants.TRADING_GOODS_DESCRIPTION_FORM_CONTROL_NAME;
    previousApplicationReferenceNumberFormControlName = ViewApplicationDetailsItamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_CONTROL_NAME;
    referenceNumberFormControlName = ViewApplicationDetailsItamsConstants.REFERENCE_NUMBER_CONTROL_NAME;
    tradeGoodsFormControlName = ViewApplicationDetailsItamsConstants.TRADING_GOODS_CONTROL_NAME;
    // constants
    validationMessages = ViewApplicationDetailsItamsConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    // variables
    detailsForm;
    applicationTypes = [];
    tradingGoods = [];
    showPreviousApplicationReferenceNumberField = false;
    selectedApplicationSubscription;
    getLookupsObservableSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appControllerService, changeDetectorRef, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
        this.routerParamsService = routerParamsService;
        this.listenForRouteParamChange();
    }
    ngOnInit() {
        this.initForm();
        if (this.aflaModuleStrategyService.lookups.has(ViewApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME)) {
            this.applicationTypes = this.aflaModuleStrategyService.lookups.get(ViewApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME);
            if (this.aflaModuleStrategyService.lookups.has(ViewApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME)) {
                this.tradingGoods = this.aflaModuleStrategyService.lookups.get(ViewApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME);
            }
            this.subscribeToSelectedApplication();
        }
        else {
            this.getLookups();
        }
    }
    loadMetadata(stepMeta) {
    }
    handleRouteChange() {
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
    }
    getLookups() {
        const params = {
            $filter: `(moduleId eq ${this.appControllerService.selectedModuleID}) and ((name eq '${ViewApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME}' and deleted eq false) or (name eq '${ViewApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME}' and deleted eq false))`
        };
        this.getLookupsObservableSubscription = this.applicationViewService
            .getLookupsObservable(params).subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(ViewApplicationDetailsItamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const tradingGoods = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name?.trim().toLowerCase() === `${ViewApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME?.trim().toLowerCase()}`) {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name?.trim().toLowerCase() === `${ViewApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME?.trim().toLowerCase()}`) {
                    tradingGoods.push(JSON.parse(item.content));
                }
            });
            this.aflaModuleStrategyService.lookups.set(`${ViewApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME}`, applicationTypes);
            this.aflaModuleStrategyService.lookups.set(`${ViewApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME}`, tradingGoods);
            this.applicationTypes = applicationTypes;
            this.tradingGoods = tradingGoods;
            this.changeDetectorRef.markForCheck();
            this.subscribeToSelectedApplication();
        }
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.setApplicationDetails(application);
            }
        });
    }
    setApplicationDetails(application) {
        this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        this.detailsForm.get(this.descriptionFormControlName).disable();
        this.setSelectedApplicationType(application.type);
        this.detailsForm.get(this.applicationTypeFormControlName).setValue(application.type);
        this.detailsForm.get(this.applicationTypeFormControlName).disable();
        const tradingGoodsFormArray = this.getTradingGoods();
        tradingGoodsFormArray.clear();
        application.tradeGoods.forEach(savedTradeGood => {
            this.tradingGoods.forEach(tradeGoodLookupOption => {
                if (tradeGoodLookupOption.value === savedTradeGood.tradeGoods) {
                    const tradingGroupForm = new FormGroup({
                        id: new FormControl(savedTradeGood.id),
                        applicationId: new FormControl(savedTradeGood.applicationId),
                        tradeGoods: new FormControl({ value: savedTradeGood.tradeGoods, disabled: true }),
                        tradingGoodsDescription: new FormControl({ value: savedTradeGood.description, disabled: true }),
                    });
                    tradingGoodsFormArray.push(tradingGroupForm);
                }
            });
        });
        if (this.showPreviousApplicationReferenceNumberField) {
            this.detailsForm.get(this.previousApplicationReferenceNumberFormControlName).setValue(application.previousReferenceNumber);
        }
        this.detailsForm.get(this.referenceNumberFormControlName).setValue(application.referenceNumber);
        this.detailsForm.get(this.referenceNumberFormControlName).disable();
        this.detailsForm.get(this.previousApplicationReferenceNumberFormControlName).setValue(application.previousReferenceNumber);
        this.detailsForm.get(this.previousApplicationReferenceNumberFormControlName).disable();
    }
    setSelectedApplicationType(selectedApplicationType) {
        const previousApplicationReferenceNumberFormControl = this.detailsForm.get(this.previousApplicationReferenceNumberFormControlName);
        if (selectedApplicationType && selectedApplicationType.trim().toLowerCase() === "renewal") {
            previousApplicationReferenceNumberFormControl.addValidators(Validators.required);
            previousApplicationReferenceNumberFormControl.updateValueAndValidity();
            this.showPreviousApplicationReferenceNumberField = true;
        }
        else {
            previousApplicationReferenceNumberFormControl.clearValidators();
            previousApplicationReferenceNumberFormControl.updateValueAndValidity();
            this.showPreviousApplicationReferenceNumberField = false;
        }
        // this.changeDetectorRef.detectChanges();
    }
    getTradingGoods() {
        return this.detailsForm.get("tradeGoods");
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationDetailsItamsComponent = __decorate([
    Component({
        selector: "app-view-application-details-itams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], ViewApplicationDetailsItamsComponent);
export { ViewApplicationDetailsItamsComponent };
